<template>
  <div>
    <Header title="我的奖券" />
    <div class="page-container">
      <van-tabs v-model="active" animated title-active-color="#f44" @change="tabChange" swipeable>
        <van-tab v-for="item in tabList" :title="item" :key="item">
          <van-pull-refresh v-model="reLoading" @refresh="onRefresh">
            <van-list v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="loadMore"  v-if="couponList.length" :offset="10">
              <div v-for="(item, index) in couponList" :key="index" class="coupon-list">
                <LotteryCouponCard :coupon-info='item' />
              </div>
            </van-list>
            <div class="page-img" v-else v-show="hasLoading">
              <img src="../../assets/images/lottery/no-data.png">
              <div>{{ noDataMsg }}</div>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import lotteryApi from '@/api/lottery'
import LotteryCouponCard from './components/lottery-coupon-card'
export default {
  name: 'LotteryCoupon',
  components: {
    Header,
    LotteryCouponCard
  },
  data () {
    return {
      active: 0,
      tabList: ['全部', '未开奖', '已开奖'],
      couponList: [],
      listLoading: false,
      finished: false,
      reLoading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        lotteryStatus: ''
      },
      hasLoading: false,
      noDataMsg: '您还未获得奖券，返回继续扫码',
      flag: true
    }
  },

  created () {
    this.getCouponList(true)
  },

  methods: {

    // tab切换
    tabChange (val) {
      if (!val) {
        this.queryParam.lotteryStatus = ''
        this.noDataMsg = '您还未获得奖券，返回继续扫码'
      } else {
        this.queryParam.lotteryStatus = val - 1
        if (!this.queryParam.lotteryStatus) {
          this.noDataMsg = '无未开奖奖券'
        } else {
          this.noDataMsg = '无已开奖奖券'
        }
      }
      this.couponList = []
      this.hasLoading = false
      this.queryParam.page = 1
      this.finished = false
      this.getCouponList(true)
    },

    // 卡券列表
    getCouponList (load) {
      if (load) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
      }
      lotteryApi.getCouponList(this.queryParam).then(res => {
        this.hasLoading = true
        this.$toast.clear()
        this.reLoading = false
        this.listLoading = false
        this.flag = true
        if (res.data.resultCode === '0') {
          const data = res.data.resultData
          if (data.activityScanLotteryList) {
            this.couponList = this.couponList.concat(data.activityScanLotteryList)
          } else {
            this.couponList = []
          }
          if (this.queryParam.page === data.pageInfo.totalPages) {
            this.finished = true
          } else {
            this.queryParam.page++
          }
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    // 下拉刷新
    onRefresh () {
      this.queryParam.page = 1
      this.queryParam.pageSize = 10
      this.couponList = []
      this.hasLoading = false
      this.finished = false
      this.getCouponList(true)
    },

    // 上拉加载
    loadMore () {
      if (this.flag) {
        this.flag = false
        this.getCouponList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  padding-top: 45px;
  .coupon-list {
    margin-top: 15px;
  }
  .page-img {
    text-align: center;
    padding: 30px 0 200px 0;
    img {
      width: 86px;
      height: 80px;
    }
    div {
      margin-top: 10px;
    }
  }
}
</style>
